import { useEffect, useState } from "react";

const KEY_DISMISSED = "cookie_notice_dismissed";

// Same fixed-bottom-banner pattern as anyainow's CookieBanner, simplified to
// a single acknowledgment rather than an Accept/Decline choice — freeainow
// has exactly one cookie (the strictly-necessary login session) and no
// analytics/tracking cookies, so there's no real second option to offer.
export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    function check() {
      try {
        if (!localStorage.getItem(KEY_DISMISSED)) setVisible(true);
      } catch {
        /* localStorage unavailable */
      }
    }
    check();
    window.addEventListener("reopen-cookie-banner", check);
    return () => window.removeEventListener("reopen-cookie-banner", check);
  }, []);

  function dismiss() {
    try {
      localStorage.setItem(KEY_DISMISSED, "1");
    } catch {
      /* ignore */
    }
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div className="cookie-banner-wrap">
      <div className="cookie-banner card">
        <p>
          We use a single strictly-necessary cookie to keep you signed in. No
          analytics, advertising, or tracking cookies.{" "}
          <a href="/privacy#cookies">Cookie policy</a>
        </p>
        <button className="primary btn-compact" onClick={dismiss}>
          Got it
        </button>
      </div>
    </div>
  );
}
